const NotFoundPage = () => {
  window.location.replace('/error.html');
};

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/script/pages/NotFoundPage.js